import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Handshake, HardHat, Users } from "lucide-react";
import { Reveal } from "@/components/layout/Shell";

const iconMap = { Users, BookOpen, Handshake, HardHat };

export const QuickActions = ({ items = [] }) => (
  <section className="quick-section">
    <div className="container quick-grid">
      {items.map((item, i) => {
        const Icon = iconMap[item.icon] || Users;
        return (
          <Reveal key={item.id} delay={i * 0.08}>
            <Link to={item.url || "/about"} className="quick-item" data-testid={`quick-action-${i}`}>
              <span className="quick-icon"><Icon size={22} /></span>
              <div><b>{item.title}</b><p>{item.description}</p></div>
              <ArrowRight size={16} />
            </Link>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export const StatsBand = ({ stats = [] }) => (
  <section className="stats-band">
    <div className="container stats-grid">
      {stats.map((s, i) => (
        <Reveal key={s.id} delay={i * 0.1} data-testid={`stat-${s.id}`}>
          <strong>{s.number}</strong>
          <b>{s.label}</b>
          <span>{s.description}</span>
        </Reveal>
      ))}
    </div>
  </section>
);

export const AboutSection = ({ tagline }) => (
  <section className="section about-section">
    <div className="container split">
      <Reveal>
        <span className="eyebrow">A community built on craft</span>
        <h2>Stronger together.<br /><em className="gold-text">Better for everyone.</em></h2>
        <p className="lead">
          DCEA is a professional home for diploma civil engineers across Hubli–Dharwad —
          a place to exchange knowledge, find opportunity and give back to the profession.
        </p>
        <Link to="/about" className="text-link" data-testid="about-read-more">
          Read more about DCEA <ArrowRight size={15} />
        </Link>
      </Reveal>
      <Reveal delay={0.15} className="about-image">
        <img
          src="https://images.unsplash.com/photo-1709934645644-f055bb2b75de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Modern civil engineering structure"
          data-testid="about-image"
        />
        <span>{tagline || "Connect · Contribute · Build · Grow"}</span>
      </Reveal>
    </div>
  </section>
);

export const PresidentMessage = ({ president }) => {
  if (!president) return null;
  return (
    <section className="section president-section">
      <div className="container president-wrap" data-testid="president-message">
        <Reveal className="president-portrait">
          <img src={president.image} alt={president.name} />
          <span className="quote-mark">“</span>
        </Reveal>
        <Reveal delay={0.15} className="president-body">
          <span className="eyebrow">A message from the president</span>
          <h2>Together, we build <span className="gold-text">what matters.</span></h2>
          <p>
            {president.message ||
              "As we grow our community of diploma civil engineers, we remain committed to sharing knowledge, championing opportunity, and giving back to the region that has shaped us."}
          </p>
          <strong>{president.name}</strong>
          <span className="president-role">{president.position} · {president.term || "DCEA Hubli–Dharwad"}</span>
          <Link to="/leadership" className="text-link" data-testid="president-read-more">
            Read more <ArrowRight size={14} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
